// Animated install device mockup (iOS Safari share-sheet / Android Chrome menu)
// + caption. Shared by the Install screen and onboarding step 5. Styles live in
// mockup.css, scoped under .hq-install (this component renders that wrapper).

import type { ReactNode } from 'react'
import './mockup.css'

interface DeviceMockupProps {
  os: string
  caption?: ReactNode
}

export default function DeviceMockup({ os, caption }: DeviceMockupProps) {
  return (
    <div className="hq-install">
      {os === 'ios' ? (
        <div className="os-panel">
          <div className="install-stage">
            <div className="device" aria-hidden="true">
              <div className="screen">
                <div className="page-bars">
                  <i className="w80" /><i className="w60" /><i /><i className="w70" /><i className="w45" />
                </div>
                <div className="ios-bar">
                  <svg className="nav" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
                  <div className="ios-addr">
                    <svg className="glob" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18" /></svg>
                    <span className="url">app.humanteq.com</span>
                  </div>
                  <div className="ios-more">
                    <svg viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="1.7" /><circle cx="12" cy="12" r="1.7" /><circle cx="19" cy="12" r="1.7" /></svg>
                  </div>
                </div>
                <div className="ios-pop">
                  <div className="pop-row share"><span>Поделиться</span>
                    <svg className="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 15V4" /><polyline points="8 8 12 4 16 8" /><path d="M6 12v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6" /></svg>
                  </div>
                  <div className="pop-row"><span>Закладки</span>
                    <svg className="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 4h12v16l-6-4-6 4z" /></svg>
                  </div>
                </div>
                <div className="ios-sheet">
                  <div className="sheet-grabber" />
                  <div className="sheet-head"><span className="logo">h</span><span className="nm">Humanteq<small>app.humanteq.com</small></span></div>
                  <div className="sheet-row"><span>В Избранное</span>
                    <svg className="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 3 14.6 9 21 9.5 16 13.8 17.6 20 12 16.6 6.4 20 8 13.8 3 9.5 9.4 9" /></svg>
                  </div>
                  <div className="sheet-row home"><span>На экран «Домой»</span>
                    <svg className="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="4" /><path d="M12 8v8M8 12h8" /></svg>
                  </div>
                  <div className="sheet-row"><span>Найти на странице</span>
                    <svg className="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="6" /><path d="M20 20l-3.5-3.5" /></svg>
                  </div>
                </div>
                <span className="touch ios-touch" />
              </div>
            </div>
          </div>
          {caption ?? (
            <p className="install-caption"><b>•••</b> &nbsp;→&nbsp; <b>Поделиться</b> &nbsp;→&nbsp; <b>«На&nbsp;экран&nbsp;„Домой"»</b></p>
          )}
        </div>
      ) : (
        <div className="os-panel">
          <div className="install-stage">
            <div className="device" aria-hidden="true">
              <div className="screen">
                <div className="and-topbar"><span className="addr" />
                  <svg className="dots" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="12" cy="19" r="1.6" /></svg>
                </div>
                <div className="page-bars" style={{ paddingTop: 40 }}>
                  <i className="w70" /><i className="w45" /><i /><i className="w60" />
                </div>
                <div className="and-menu">
                  <div className="m-row">Новая вкладка</div>
                  <div className="m-row add">Добавить на главный экран</div>
                  <div className="m-row">История</div>
                </div>
                <span className="touch and-touch" />
              </div>
            </div>
          </div>
          {caption ?? (
            <p className="install-caption">Меню <b>⋮</b> &nbsp;→&nbsp; <b>«Добавить на&nbsp;главный&nbsp;экран»</b></p>
          )}
        </div>
      )}
    </div>
  )
}
